import React, { useEffect, useState, useRef, memo } from 'react';
import {
    Box,
    Grow,
    Divider,
    Stack,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    Tooltip,
    Collapse,
    ListSubheader,

} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import TimelineIcon from '@mui/icons-material/Timeline';
import ChatItemOptionsMenu from './ChatItemOptionsMenu';
import { ManagerContext } from '../../contexts/ManagerContext';
import { OpenAiContext } from '../../contexts/OpenAiContext';
import AlertDialogSlide from '../AlertDialogSlide';
import AddIcon from '@mui/icons-material/Add';
import { ThreeDRotationOutlined } from '@mui/icons-material';
import OpenAI from 'openai';
import { Messages } from 'openai/resources/beta/threads/messages.mjs';

const TypingEffect = React.memo(({ text }) => {
    const [ displayedText, setDisplayedText ] = useState('');
    const textRef = useRef(text);
    const element = useRef(null);
    
    useEffect(() => {
        textRef.current = text;
        let index = 0;
        let interval;
    
        if (text && text.length > 0) {
            // Reset displayedText at the start of typing
            setDisplayedText(''); // Reset display text on new input
            index = 0; // Reset index on new text
            
            interval = setInterval(() => {
                if (index < textRef.current.length) {
                    setDisplayedText(prev => prev + textRef.current[index]);
                    index++;
                } else {
                    clearInterval(interval);
                }
            }, 30);
        }
    
        return () => clearInterval(interval);
    }, [text]);

    return (
        <Tooltip title={text}>
            <Typography variant="inherit" noWrap ref = {(el) => (element.current = el)}>
            {displayedText}
            </Typography>
            {/* <ListItemText 
            ref = {(el) => (element.current = el)}
            primary={displayedText} sx={{ overflow: 'hidden', width: '230px' }} /> */}
        </Tooltip>
    );
});

export default function ThreadsContainer({ open }) {
    const { currentUser, sendTask, connectionState } = React.useContext(ManagerContext);
    const { openai,
        stream, setStream,
        forwardAuto, setForwardAuto,
        activeRun, setActiveRun, chat, fetchMessages, setMessages, setChat, createThread, updateThreads, fetch_thread_delete } = React.useContext(OpenAiContext);
    const [open7, setOpen7] = React.useState(true);
    const [ selected, setSelected ] = React.useState(-1);

  const handleClick = () => {
    setOpen7(!open7);
  };

    const handleConfirm = async () => {
        console.log('handleConfirm');
        // await sendTask({
        //     type: 'delete_thread',
        //     payload: {
        //         thread_id: thread.id,
        //     },
        // });
    }
    const [ dialogState, setDialogState ] = useState({
        title: 'Delete Thread',
        description: 'Are you sure you want to delete this thread?',
        additional_description: null,
        open: false,
        text_field: false,
        thread: null,
        confirm: handleConfirm,
    });

    useEffect(() => {
        // Działania związane z websocketem, jeśli potrzebne
    }, [connectionState]);

    const handleChangeThread = async (thread) => {
        if (thread.id === chat.activeThread.id) return
        forwardAuto.func(true);
        console.log('handleChangeThread', thread.id);
        setChat((prev) => ({ ...prev, activeThread: thread })); 
        setMessages([]);
        const _messages = await fetchMessages(thread.id);
        if (_messages.body.has_more){
            setMessages(prev => {
                const newPrev = [..._messages.data, {id: 'has_more', last_id: _messages.body.last_id, role: 'system'}]
                return newPrev
            })
        }else{
            if(_messages.data.length > 0){
                setMessages(_messages.data)
            }
            // else{
            //     const result_instruction = await sendTask('get_instruction');
            //     const stream = await openai.beta.threads.runs.create(
            //         chat.activeThread.id,
            //         { 
            //             assistant_id: chat.assistant_id,
            //             instructions: JSON.stringify(result_instruction.data.instructions),
            //             additional_instructions: null,
            //             stream: true,
            //             reasoning_effort: null,
            //             tools: [{ type: "file_search"}],
            //             model: "gpt-4o-mini",
            //         }
            //     );
            //     setStream(stream);
            //     return
            // }
        }
        if(_messages.data.length === 0) return
        console.log(_messages.data)
        let run_id = _messages.data[0].run_id;
        if (!run_id && _messages.data.length > 1) {
        run_id = _messages.data[1].run_id;
        }
        if (run_id) {
            const run = await openai.beta.threads.runs.retrieve(
                thread.id,
                run_id
            );
            const status = run.status==="completed"?'ready':run.status==='in_progress'?'run':'wait';
            setActiveRun((prev) => ({...prev, status: status, id: run.id}));
        }
    };

    const handleNewChat = async () => {
        // await createThread();
        setChat((prev) => ({ ...prev, activeThread: 'new_chat' }));
        setMessages([]);
        console.log('new_chat');
        setActiveRun({state: 'ready'});
    };

    const handleRename = async () => {
        setDialogState(prev => ({ ...prev, open: true, text_field: true, title: 'Rename Thread', description: 'Enter new name:'}));
    };
    
    const handleFreezeName = async (thread, value) => {
        const freeze_name = value.target.checked ? 'false' : 'true';
        console.log('freeze_name', freeze_name)
        console.log('value', value.target.checked)
        await updateThreads(thread, {freeze_name: 'false'})
    };

    const actionRename = async (thread, new_name) => {
        await updateThreads(thread, {name: new_name, freeze_name: 'false'})
    };


    const dialogDelete = async (thread) => {
        setDialogState(prev => ({...prev, thread: thread, open: true, additional_description: thread.metadata?.name ? thread.metadata.name : thread.id, confirm: handleDelate}));
    };
    const handleDelate = async (thread) => {
        await fetch_thread_delete(thread.id)
    };


    const linear = chat.threads.find(item => { return item?.metadata?.type === 'linear' })

    return (
        <>
            <AlertDialogSlide state={dialogState}/>  
            {open &&<List dense sx={{ height: '100%'}}
            subheader={<Typography sx={{ color: 'white', textAlign: 'center', mt: 2}}>Chats:</Typography>}>
                
                <ListItem disablePadding sx={{ opacity: open ? 1 : 0, display: 'block',mb: 3 }}>
                { linear && 
                    <ListItemButton 
                    selected={chat.activeThread?.metadata?.type === 'linear'}
                    onClick={() => handleChangeThread(linear, -1)} sx={{ paddingRight: '30px' }}>
                        <ListItemIcon sx={{ color: 'white', textAlign: 'center' }}>
                            <TimelineIcon />
                        </ListItemIcon>
                        <ListItemText primary='Sofia' sx={{ overflow: 'hidden', width: '250px' }} />
                    </ListItemButton>
                }
                {/* <Divider /> */}
                {/* NEW CHAT */}
                {currentUser && <ListItemButton 
                // sx={{bgcolor: 'blue'}}
                selected={chat.activeThread==='new_chat'}
                onClick={handleNewChat}>
                    
                    <ListItemIcon sx={{ color: 'white', textAlign: 'center' }}>
                    </ListItemIcon>
                    <ListItemText primary='New Chat' />
                    <AddIcon />
                </ListItemButton>}
                {currentUser && chat.threads?.length > 0 &&
                    <ListItemButton 

                    onClick={handleClick}>
                    <ListItemText primary='history:' />
                    {open7 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>}
                </ListItem>
                <Collapse in={open7} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{
                    width: '100%',
                    mb: 0,
                    maxWidth: 360,
                    // bgcolor: 'unset',
                    // position: 'relative',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    // maxHeight: 500,
                    
                    '& ul': { padding: 0 },
                }}>

                    {currentUser && chat?.threads?.map((item, index) => {
                        if(item?.metadata?.type !== 'linear'){
                            return(
                                <ListItem key={item.id} disablePadding sx={{ opacity: open ? 1 : 0, display: 'block' }}>
                                    <Stack direction="row">
                                        <ListItemButton 
                                        selected={item.id === chat.activeThread?.id}
                                        onClick={() => handleChangeThread(item)} >
                                            <TypingEffect text={item?.metadata?.name? item.metadata.name : item.id}/>
                                        </ListItemButton>
                                        <ChatItemOptionsMenu thread={item} handleFreeze={handleFreezeName} handleDelete={dialogDelete} handleRename={handleRename} edge="end" aria-label="comments" />
                                    </Stack>
                                </ListItem>
                            )
                        }else{
                            return null;
                        }
                        
                    })}
                    </List>
                </Collapse>
            </List>}
            {!open && currentUser && 
            <ListItem disablePadding>
            <ListItemButton onClick={ handleNewChat } sx={{ top: 0, paddingRight: '30px', height: '100px' }}>
            <ListItemIcon sx={{ color: 'white', textAlign: 'center'}}>
                <LibraryAddIcon />
            </ListItemIcon>
            </ListItemButton>
            </ListItem>}
        </>
    );
}